import { render, staticRenderFns } from "./IlloNeighborhood.vue?vue&type=template&id=e329b532"
import script from "./IlloNeighborhood.vue?vue&type=script&lang=js"
export * from "./IlloNeighborhood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports